/* loder actions */
export const SHOW = "SHOW";
export const HIDE = "HIDE";
export const PENDING = "PENDING";
export const DONE = "DONE";

/* locale actions */
export const SET_LOCALE = "SET_LOCALE";
export const SET_LANGUAGES = "SET_LANGUAGES";

/* currency actions */
export const SET_CURRENCY = "SET_CURRENCY";
export const SET_CURRENCIES = "SET_CURRENCIES";

/* tNotification actions */
export const PUSH_NOTIFICATION = "PUSH_NOTIFICATION";
export const POP_NOTIFICATION = "POP_NOTIFICATION";
export const UPDATE_NOTIFICATION_VISIBILITY = "UPDATE_NOTIFICATION_VISIBILITY";
export const UPDATE_NOTIFICATIONS_COUNT = "UPDATE_NOTIFICATIONS_COUNT";

export const SWITCH_DIALOG = "SWITCH_DIALOG";
export const SET_DIALOG_SETTINGS = "SET_DIALOG_SETTINGS";
export const SET_DIALOG_COMPONENT = "SET_DIALOG_COMPONENT";

export const GET_CATALOG = "GET_CATALOG";

export const GET_WATCHLIST_LIST = "GET_WATCHLIST_LIST";
export const ADD_RECORD_TO_WATCHLIST = "ADD_RECORD_TO_WATCHLIST";
export const REMOVE_RECORD_FROM_WATCHLIST = "REMOVE_RECORD_FROM_WATCHLIST";

export const SHOW_TOAST_MESSAGE = "SHOW_TOAST_MESSAGE";
export const ROUTER_PUSH = "ROUTER_PUSH";

export const CHECK_TOKEN = "CHECK_TOKEN";

export const SELECTED_DATA_TABLE = "SELECTED_DATA_TABLE";
export const CHECK_AUTH_TOKEN = "CHECK_AUTH_TOKEN";


/* General Values Actions */

export const GET_WEBSITE_INFO = "GET_WEBSITE_INFO";
export const GET_IMAGES = "GET_IMAGES";
export const GET_SLUGS = "GET_SLUGS";
export const GET_WEBSITE_TEXT = "GET_WEBSITE_TEXT";

export const GET_LEGAL_TEXT = "GET_LEGAL_TEXT";
export const GET_EVENTS_LENGTH = "GET_EVENTS_LENGTH";

export const ADD_KEYWORDS = "ADD_KEYWORDS";

export const SET_COUNTRY = "SET_COUNTRY";

export const SET_API_COUNTRIES = "SET_API_COUNTRIES";
export const SET_STATES_BY_COUNTRY = "SET_STATES_BY_COUNTRY";
export const SET_CITIES_BY_STATES = "SET_CITIES_BY_STATES";
